module.exports = __webpack_public_path__ + "static/media/full_1.472c9119.jpg";